import React from 'react';
import Header from './Header';
import "./Header.scss";

const CustomHeader = (props) => (
  <Header {...props}>
        IBM&nbsp;<span>Accessibility</span>
</Header>
);

export default CustomHeader;
